// extracted by mini-css-extract-plugin
module.exports = {"ColorBlue":"NoResults_ColorBlue__3EEs8","Upercase":"NoResults_Upercase__2uHbF"};